import * as actionTypes from '../actions/actionsTypes';

const initialState = {
        userData: {
            data: {
                "accessToken": localStorage.getItem('accessToken'),
                "user_id": localStorage.getItem('user_id'),
                "club_id": localStorage.getItem('club_id'),
                "first_name": localStorage.getItem('first_name'),
                "last_name": localStorage.getItem('last_name'),
                "user_name": localStorage.getItem('user_name'),
                "email": localStorage.getItem('email'),
                "active": localStorage.getItem('active'),
                "role": localStorage.getItem('role'),
                "tes_user_id": localStorage.getItem('tes_user_id')

            },
        }
    };


export const userReducer = (state = initialState, action) => {
    switch (action.type ){
        case actionTypes.CREATE_USER:
            return {
                ...state,
                userData: action.payload,
            };
        case actionTypes.UPDATE_USER:
            return {
                ...state,
                userData: action.payload,
            };
        case actionTypes.FETCH_USER_DATA:
            return {
                ...state,
                userData: action.payload,
            };
        case actionTypes.DELETE_USER:
            return {
                ...state,
                userData: action.payload,
            };


        default:
            return state;
    }

};
